/**
 * @param {HTMLImageElement} image - Image File Object
 * @param {Object} crop - crop Object
 * @param {String} fileName - Name of the returned file in Promise
 */
export function getCroppedImg(image, crop, fileName) {
  const canvas = document.createElement('canvas')
  canvas.crossOrigin = 'anonymous'

  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height

  canvas.width = crop.width
  canvas.height = crop.height
  const ctx = canvas.getContext('2d')

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  )

  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (!blob) {
        reject(new Error('Canvas is empty'))
        return
      }

      blob.name = fileName
      resolve(this.fileUrl)
    }, 'image/jpeg')
  })
}

/**
 * @param {Number} height
 * @param{Number} width
 * @return {String}
 */
export function getAspectRatio(width, height) {
  width = parseInt(width, 10)
  height = parseInt(height, 10)

  // Should return invalid.
  if (width === 0 || height === 0) {
    return '0:0'
  }

  if (width === height) {
    return '1:1'
  }

  if (width === 1 || height === 1) {
    return `${width}:${height}`
  }

  const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b))
  const highestFirst = (a, b) => (a < b ? [b, a] : [a, b])

  const [a, b] = highestFirst(width, height)
  const divisor = gcd(a, b)

  return `${width / divisor}:${height / divisor}`
}

export function makeAspectCrop(crop, imageWidth, imageHeight) {
  if (isNaN(crop.aspect)) {
    console.warn('`crop.aspect` should be a number in order to make an aspect crop', crop)
    return crop
  }

  const completeCrop = {
    unit: 'px',
    x: 0,
    y: 0,
    ...crop
  }

  if (crop.width) {
    completeCrop.height = completeCrop.width / crop.aspect
  }

  if (crop.height) {
    completeCrop.width = completeCrop.height * crop.aspect
  }

  if (completeCrop.y + completeCrop.height > imageHeight) {
    completeCrop.height = imageHeight - completeCrop.y
    completeCrop.width = completeCrop.height * crop.aspect
  }

  if (completeCrop.x + completeCrop.width > imageWidth) {
    completeCrop.width = imageWidth - completeCrop.x
    completeCrop.height = completeCrop.width / crop.aspect
  }

  return completeCrop
}

export function getFrameAspect(frameSize) {
  let aspect = frameSize.frame_aspect_ratio || '0:0'

  aspect = aspect.split(':')

  return (aspect[0] || 1) / (aspect[1] || 1)
}

export function getReverseFrameAspect(frameSize) {
  let aspect = frameSize.frame_aspect_ratio || '0:0'

  aspect = aspect.split(':')

  return (aspect[1] || 1) / (aspect[0] || 1)
}

/**
 * @param {Number} width
 * @param {Number} height
 * @return {String}
 */
export function getOrientation(width, height) {
  if (width === height) {
    return 'square'
  }

  return width > height ? 'landscape' : 'portrait'
}
